<div class="tw-font-body tw-flex tw-flex-col tw-h-screen tw-bg-gray-100">
  <!-- Header -->
  <div class="flex-heading">
    <div class="tw-bg-black tw-h-14 tw-px-6 tw-flex tw-items-center tw-w-full tw-justify-center tw-z-[100]">
      <div class="tw-absolute tw-left-6 tw-top-2 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="back()">
        <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50" [iconName]="'arrow_back'"></cs-icon>
      </div>
      <span class="tw-font-body tw-font-bold tw-text-300 tw-text-white" i18n="@@changeLanguage">Change Language</span>
    </div>
  </div>

  <!-- Content -->
  <div class="tw-flex tw-flex-col tw-gap-4 tw-p-6 tw-overflow-y-auto">

    <!-- App Language -->
    <div class="tw-flex tw-flex-col tw-gap-3">
      <p class="tw-font-body tw-font-bold tw-text-600 tw-text-gray-900"
        i18n="@@appLanguage">App Language</p>
      <div class="tw-bg-white tw-rounded-[10px] tw-shadow-[0_2px_4px_0px_rgba(0,0,0,0.1)] tw-h-16
        tw-flex tw-items-center tw-justify-between tw-px-4 tw-cursor-pointer"
        (click)="openAppLanguageSheet()">
        <div class="tw-flex tw-items-center tw-gap-2">
          <span class="tw-font-body tw-text-400 tw-text-gray-900">{{appLanguage()?.displayName}}</span>
          @if (showUpdatedBadge()) {
            <div class="tw-flex tw-items-center tw-gap-1.5">
              <span class="tw-font-body tw-text-200 tw-font-medium tw-text-teal-500" i18n="@@languageUpdated">Updated</span>
              <cs-icon class="tw-h-4 tw-w-4 tw-text-teal-500" iconName="done"></cs-icon>
            </div>
          }
        </div>
        <em class="cs-icon-arrow tw-align-middle tw-text-teal-600 tw-rotate-90"></em>
      </div>
    </div>

    <!-- App Language hint -->
    <div class="tw-flex tw-gap-1.5 tw-items-start">
      <em class="cs-icon-info tw-text-gray-400 tw-text-300 tw-shrink-0 tw-mt-0.5"></em>
      <p class="tw-font-body tw-text-300 tw-text-gray-400 tw-leading-300"
        i18n="@@appLanguageHint">The app will be shown in the selected language.</p>
    </div>

    <!-- Communication Language: dropdown when English, info card when non-English allowed -->
    @if (isAllowedCommunicationLanguage()) {
      <div class="tw-flex tw-flex-col tw-gap-3 tw-mt-[44px]">
        <p class="tw-font-body tw-font-bold tw-text-600 tw-text-gray-900"
          i18n="@@communicationLanguage">Communication Language</p>

        <!-- Dropdown (English only) -->
        @if (isAppLanguageEnglish()) {
          <div class="tw-bg-white tw-rounded-[10px] tw-shadow-[0_2px_4px_0px_rgba(0,0,0,0.1)] tw-h-16
            tw-flex tw-items-center tw-justify-between tw-px-4 tw-cursor-pointer"
            (click)="openCommunicationLanguageSheet()">
            <div class="tw-flex tw-items-center tw-gap-2">
              <span class="tw-font-body tw-text-400 tw-text-gray-900">{{communicationLanguage()?.displayName}}</span>
              @if (showCommLangUpdatedBadge()) {
                <div class="tw-flex tw-items-center tw-gap-1.5">
                  <span class="tw-font-body tw-text-200 tw-font-medium tw-text-teal-500" i18n="@@languageUpdated">Updated</span>
                  <cs-icon class="tw-h-4 tw-w-4 tw-text-teal-500" iconName="done"></cs-icon>
                </div>
              }
            </div>
            <em class="cs-icon-arrow tw-align-middle tw-text-teal-600 tw-rotate-90"></em>
          </div>
        }

        <!-- Info card (non-English) -->
        @if (!isAppLanguageEnglish()) {
          <div class="tw-rounded-[10px] tw-bg-orange-75 tw-flex tw-items-center tw-px-4 tw-py-4">
            <p class="tw-font-body tw-text-300 tw-font-medium tw-text-gray-500" i18n="@@appVoiceNotesLanguageInfo">
              Your app &amp; doctor voice notes will be in {{appLanguage()?.displayName}}
            </p>
          </div>
        }
      </div>

      <!-- Communication Language hint -->
      <div class="tw-flex tw-gap-1.5 tw-items-start">
        <img src="/assets/icons/document-icon.svg" class="tw-h-4 tw-w-4 tw-shrink-0 tw-mt-0.5" alt="">
        <p class="tw-font-body tw-text-300 tw-text-gray-400 tw-leading-300"
          i18n="@@communicationLanguageHint">Doctor messages &amp; voice notes will be in the selected language.</p>
      </div>
    }

  </div>
</div>
